const routerList = [
  {
    label: "navbar.home",
    path: "/home"
  },
  { 
    label: "navbar.product",
    path: "/product",
    children: [
      {
        label: "navbar.ioTHardware",
      },
      {
        label: "navbar.electricEquipment",
      },
      // {
      //   label: "navbar.softwarePlatform",
      //   // path: "/"
      // }
    ]
  },
  {
    label: "navbar.solution",
    path: "/solution"
  },
  {
    label: "navbar.shop",
  },
  {
    label: "navbar.customization",
    path: "/customization"
  },
  {
    label: "navbar.community",
    children: [
      {
        label: "navbar.discord",
      },
      {
        label: "navbar.twitter",
      },
    ]
  },
  {
    label: "navbar.aboutUs",
    path: "/aboutus"
  },
  {
    label: "navbar.contact",
    path: "/contact"
  },
  {
    label:"navbar.lang"
  }
];
export default routerList;



// WEBPACK FOOTER //
// ./src/utils/routerList.js